import { render, staticRenderFns } from "./OutboundList.vue?vue&type=template&id=64343c19&scoped=true&"
import script from "./OutboundList.vue?vue&type=script&lang=js&"
export * from "./OutboundList.vue?vue&type=script&lang=js&"
import style0 from "./OutboundList.vue?vue&type=style&index=0&id=64343c19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64343c19",
  null
  
)

export default component.exports